<template>
  <div class="waterfall-container">
    <!-- Left Column -->
    <div class="waterfall-column">
      <div
        v-for="item in leftList"
        :key="item.id"
        class="waterfall-item"
        @click="onItemClick(item)"
      >
        <div class="item-img-container">
          <img
            class="item-img"
            :style="getImgStyle(item)"
            :src="item.imageResizeUrl || item.imageSmall || ''"
          />
        </div>
        <div class="item-content">
          <div class="item-title">{{ item.content || '' }}</div>
          <div class="item-footer">
            <div class="author-info">
              <img
                class="author-avatar"
                :src="item.userCreator === null ? item.headImage : item.userCreator.image"
              />
              <span class="author-name">
                {{ item.userCreator === null ? item.creatorName : item.userCreator.name }}
              </span>
            </div>
            <div class="like-info" @click.stop="onLikeClick(item)">
              <span class="like-count">{{ item.collectSum || 0 }}</span>
              <van-icon
                :name="item.isCollected ? 'star' : 'star-o'"
                :color="item.isCollected ? '#ffb800' : '#999'"
                class="like-icon"
              />
            </div>
          </div>
        </div>
        <!-- 关联的商品信息 -->
        <div v-if="item.product" class="goods-info" @click.stop="onGoodsClick(item.product)">
          <img class="goods-img-small" :src="item.product.spuImg" />
          <div class="goods-text">
            <div class="goods-name-small">{{ item.product.name || '' }}</div>
            <div class="goods-price">¥{{ item.product.finalPrice }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Column -->
    <div class="waterfall-column">
      <div
        v-for="item in rightList"
        :key="item.id"
        class="waterfall-item"
        @click="onItemClick(item)"
      >
        <div class="item-img-container">
          <img
            class="item-img"
            :style="getImgStyle(item)"
            :src="item.imageResizeUrl || item.imageSmall || ''"
          />
        </div>
        <div class="item-content">
          <div class="item-title">{{ item.content || '' }}</div>
          <div class="item-footer">
            <div class="author-info">
              <img
                class="author-avatar"
                :src="item.userCreator === null ? item.headImage : item.userCreator.image"
              />
              <span class="author-name">
                {{ item.userCreator === null ? item.creatorName : item.userCreator.name }}
              </span>
            </div>
            <div class="like-info" @click.stop="onLikeClick(item)">
              <span class="like-count">{{ item.collectSum || 0 }}</span>
              <van-icon
                :name="item.isCollected ? 'star' : 'star-o'"
                :color="item.isCollected ? '#ffb800' : '#999'"
                class="like-icon"
              />
            </div>
          </div>
        </div>
        <!-- 关联的商品信息 -->
        <div v-if="item.product" class="goods-info" @click.stop="onGoodsClick(item.product)">
          <img class="goods-img-small" :src="item.product.spuImg" />
          <div class="goods-text">
            <div class="goods-name-small">{{ item.product.name || '' }}</div>
            <div class="goods-price">¥{{ item.product.finalPrice }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MaterialWaterfall",
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      maxRate: 1.3333333333
    };
  },
  computed: {
    leftList() {
      return this.list.filter((_, index) => index % 2 === 0);
    },
    rightList() {
      return this.list.filter((_, index) => index % 2 !== 0);
    }
  },
  methods: {
    getImgStyle(item) {
      const screenWidth = window.innerWidth > 540 ? 540 : window.innerWidth;
      const width = screenWidth / 2;
      const maxRate = 4 / 3.0;
      const maxHeight = width * maxRate;

      if (
        item.imageResizeUrlWidth &&
        item.imageResizeUrlHeight &&
        item.imageResizeUrlWidth !== 0 &&
        item.imageResizeUrlHeight !== 0
      ) {
        const realRate = item.imageResizeUrlHeight / item.imageResizeUrlWidth;
        const isMoreHeightImage = realRate > maxRate;
        const height = isMoreHeightImage ? maxHeight : realRate * width;
        return `height: ${height}px; object-fit: cover;`;
      }
      return `height: ${width}px; object-fit: cover;`;
    },
    onItemClick(item) {
      this.$emit("click", item);
    },
    onLikeClick(item) {
      this.$emit("like", item);
    },
    onGoodsClick(product) {
      this.$router.push({
        path: "/product/detail",
        query: { id: product.id }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.waterfall-container {
  display: flex;
  justify-content: space-between;
  padding: 8px;
  box-sizing: border-box;
  background-color: #f7f8fa;
}
.waterfall-column {
  width: 48.5%;
  display: flex;
  flex-direction: column;
}
.waterfall-item {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  text-align: left;
}
.item-img-container {
  width: 100%;
  position: relative;
  background-color: #f2f3f5;
  .item-img {
    width: 100%;
    display: block;
  }
}
.item-content {
  padding: 8px;
}
.item-title {
  font-size: 13px;
  color: #333;
  line-height: 1.4;
  height: 36px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-bottom: 6px;
}
.item-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.author-info {
  display: flex;
  align-items: center;
  min-width: 0;
}
.author-avatar {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  margin-right: 4px;
  object-fit: cover;
  flex-shrink: 0;
}
.author-name {
  font-size: 10px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.like-info {
  display: flex;
  align-items: center;
  color: #999;
  cursor: pointer;
}
.like-count {
  font-size: 10px;
  margin-right: 2px;
}
.like-icon {
  font-size: 12px;
}
.goods-info {
  display: flex;
  margin: 0 8px 8px 8px;
  padding: 4px;
  background-color: #fff;
  border: 1px solid #EBEBEB;
  border-radius: 2px;
  align-items: center;
  box-sizing: border-box;
}
.goods-img-small {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  margin-right: 6px;
  object-fit: cover;
  flex-shrink: 0;
  background-color: #f0f0f0;
}
.goods-text {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.goods-name-small {
  font-size: 10px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.2;
}
.goods-price {
  font-size: 10px;
  color: #333;
  margin-top: 2px;
  line-height: 1.2;
  font-weight: normal;
  text-align: left;
}
</style>
